import React, { useState } from "react";
import {
  FaLock,
  FaKey,
  FaEye,
  FaEyeSlash,
  FaSave,
  FaShieldAlt,
} from "react-icons/fa";
import "./Changepass.css";

import { BASE_URL } from "../../Config/config";

export default function Changepass() {
  const username = sessionStorage.getItem("admin_username") || "";

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setMessage("");
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (!username) {
      setError("Admin session expired. Please login again.");
      return;
    }

    if (!formData.currentPassword) {
      setError("Please enter your current password.");
      return;
    }

    if (!formData.newPassword) {
      setError("Please enter your new password.");
      return;
    }

    if (formData.newPassword.length < 6) {
      setError("New password must contain at least 6 characters.");
      return;
    }

    if (!formData.confirmPassword) {
      setError("Please confirm your new password.");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError("New password and confirm password do not match.");
      return;
    }

    if (formData.currentPassword === formData.newPassword) {
      setError("New password must be different from current password.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_URL}/admin_auth.php?action=change_password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username,
            currentPassword: formData.currentPassword,
            newPassword: formData.newPassword,
          }),
        },
      );

      const data = await response.json();

      if (!data.success) {
        setError(data.message || "Unable to change password.");
        return;
      }

      setMessage("Password changed successfully.");

      setFormData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err) {
      console.error(err);
      setError("Unable to connect to server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-page">
      <div className="change-password-card">
        {/* HEADER */}

        <div className="change-password-header">
          <div className="change-password-icon">
            <FaShieldAlt />
          </div>

          <div>
            <h2>Change Password</h2>

            <p>Update your administrator account password</p>
          </div>
        </div>

        {/* USER INFO */}

        <div className="admin-account-info">
          <div className="account-icon">
            <FaKey />
          </div>

          <div>
            <span>Admin Account</span>
            <strong>{username}</strong>
          </div>
        </div>

        {/* MESSAGE */}

        {error && <div className="change-message error">{error}</div>}

        {message && <div className="change-message success">{message}</div>}

        {/* FORM */}

        <form onSubmit={handleSubmit}>
          {/* CURRENT PASSWORD */}

          <div className="change-input-group">
            <label>Current Password</label>

            <div className="change-input-wrapper">
              <FaLock className="change-input-icon" />

              <input
                type={showCurrent ? "text" : "password"}
                name="currentPassword"
                placeholder="Enter current password"
                value={formData.currentPassword}
                onChange={handleChange}
                autoComplete="current-password"
              />

              <button
                type="button"
                className="change-password-toggle"
                onClick={() => setShowCurrent(!showCurrent)}
              >
                {showCurrent ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* NEW PASSWORD */}

          <div className="change-input-group">
            <label>New Password</label>

            <div className="change-input-wrapper">
              <FaKey className="change-input-icon" />

              <input
                type={showNew ? "text" : "password"}
                name="newPassword"
                placeholder="Enter new password"
                value={formData.newPassword}
                onChange={handleChange}
                autoComplete="new-password"
              />

              <button
                type="button"
                className="change-password-toggle"
                onClick={() => setShowNew(!showNew)}
              >
                {showNew ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <small>Password must contain at least 6 characters.</small>
          </div>

          {/* CONFIRM PASSWORD */}

          <div className="change-input-group">
            <label>Confirm New Password</label>

            <div className="change-input-wrapper">
              <FaLock className="change-input-icon" />

              <input
                type={showConfirm ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm new password"
                value={formData.confirmPassword}
                onChange={handleChange}
                autoComplete="new-password"
              />

              <button
                type="button"
                className="change-password-toggle"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                {showConfirm ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* BUTTON */}

          <button
            type="submit"
            className="change-password-button"
            disabled={loading}
          >
            <FaSave />

            {loading ? "Changing Password..." : "Change Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
